var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-footer',{attrs:{"color":"blue"}},[_c('p',{staticClass:"footer-copyright mb-0 py-3 text-center"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" Copyright: "),_c('a',{attrs:{"href":"https://myfrac.com/"}},[_vm._v(" MyFrac")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }